export const linkWrapperIgnoreAttribute = "data-ux-iws-link-wrapper-ignore";
